import { downloadFile } from '@delmonicos/shared-sdk/libs/core/src/helpers/download-file';
import { getInvoicePdfFilename } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/get-invoice-pdf-filename';
import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';

import i18n from '@app/core/locale/i18n';

export const downloadInvoicePdf = async (
  invoice: InvoiceModel,
  response: Response,
): Promise<void> => {
  await downloadFile(response, getInvoicePdfFilename(invoice, i18n));
};
